export * from './auth.guard';



// WEBPACK FOOTER //
// /codebuild/output/src2455195120/src/src/app/shared/guard/index.ts